import { changePassword, changeRecoveryQuestion } from "./okta/changePassword";
import changePasswordM from "./mulesoft/changePassword";
import { forgotPassword } from "./okta/forgotPassword";
import {
  getSession,
  getSessionUser,
  getSessionWithToken,
  sessionRefresh,
  logout,
} from "./okta/session";

import loginCallOne from "./mulesoft/login";
import mulesoftRegister from "./mulesoft/register";
import verifyToken from "./mulesoft/verifyToken";
import resetOktaPassword from "./mulesoft/resetOktaPassword";

import {
  getCallout2Url as loginCallTwoUrl,
  exchangeTokens as loginCallThree,
} from "./okta/login";
import loginCallFour from "./deloit/login";
import loginWithToken from "./okta/loginWithToken";
import loginWithProxyPdn from "./deloit/LoginWithProxyPdn";

import enrollMfa from "./deloit/enrollMfa";
import sendMfaCode from "./deloit/sendMfaCode";
import verifyMfaCode from "./deloit/verifyMfaCode";
import getEnrolledMfaList from "./deloit/getEnrolledMfaList";
import authenticateMfaCode from "./deloit/authenticateMfaCode";

/**
 * OKTA API ENDPOINTS
 */
export const okta = {
  changePassword,
  changeRecoveryQuestion,
  forgotPassword,
  getSession,
  getSessionUser,
  getSessionWithToken,
  sessionRefresh,
  loginCallTwoUrl,
  loginCallThree,
  logout,
};
/**
 * MULESOFT ENDPOINTS
 */
export const mulesoft = {
  loginCallOne,
  verifyToken,
  resetOktaPassword,
  register: mulesoftRegister,
  changePassword: changePasswordM,
};
/**
 * DELOIT ENDPOINTS
 */
export const deloit = {
  loginCallFour,
  loginWithProxyPdn,
  loginWithProxyPdn,
  enrollMfa,
  sendMfaCode,
  verifyMfaCode,
  getEnrolledMfaList,
  authenticateMfaCode,
};
/**
 * LOGIN FLOW
 */
export const loginFlow = {
  loginCallOne,
  loginCallTwoUrl,
  loginCallThree,
  loginCallFour,
  loginWithProxyPdn,
  loginWithToken,
};
export default {
  mulesoft,
  deloit,
  loginFlow,
};
